import { WebStorageStateStore } from 'oidc-client-ts';
import React from 'react';
import { AuthProvider, AuthProviderProps } from "react-oidc-context";
import { useNavigate } from "react-router-dom";

export interface HelixAuthProviderProps {
  children?: React.ReactNode;
  authClientId: string;
  authUri: string;
  siteUri: string;
  scope: string;
  silentRenewPath: string;
}

const HelixAuthProvider: React.FC<HelixAuthProviderProps> = ({ children, authClientId, authUri, siteUri, scope, silentRenewPath }) => {
  const navigate = useNavigate();

  const clientRoot = siteUri + '/';

  const oidcConfig: AuthProviderProps = React.useMemo(
    (): AuthProviderProps => ({
      scope: scope,
      authority: authUri + '/',
      client_id: authClientId,
      redirect_uri: `${clientRoot}signin-callback`,
      silent_redirect_uri: `${clientRoot}${silentRenewPath}`,
      post_logout_redirect_uri: `${clientRoot}`,
      response_type: 'code',
      automaticSilentRenew: true,
      loadUserInfo: true,
      onSigninCallback: (user) => {
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        //@ts-ignore
        const url: string | undefined = user?.state;

        window.history.replaceState({}, url ?? window.location.pathname);
        if (url) navigate(url);
      },
      userStore: new WebStorageStateStore({
        store: localStorage
      })
    }),
    [navigate, authClientId, authUri, clientRoot, scope, silentRenewPath],
  );

  return <AuthProvider {...oidcConfig}>{children}</AuthProvider>;
};

export default HelixAuthProvider;